var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { whiteSpace } from "../custom";
import React from 'react';
import { color, layout, space, typography } from 'styled-system';
import { styled } from "../utils";
var StyledText = styled.p(typography, color, space, layout, whiteSpace);
StyledText.defaultProps = {
    color: 'primary',
    fontSize: ['small', 'normal'],
    fontFamily: 'primary',
    fontWeight: 'medium',
    letterSpacing: 'normal',
    lineHeight: 'normal',
};
var Text = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(StyledText, __assign({ "data-component": "Text" }, props), children));
};
export default Text;
//# sourceMappingURL=Text.js.map